module.exports = __webpack_public_path__ + "img/small.cc63a37d.png";